<template>
  <div class="app" v-if="user">
    <AppHeader fixed>
      <SidebarToggler class="d-lg-none" display="md" mobile/>

    <!--    <img class="navbar-brand-full"

             src="https://upload.wikimedia.org/wikipedia/commons/1/1e/Logo_Regional_Cooperation_Council.png" height="40"
             alt="rcc">
             -->
        <img class="navbar-brand-full d-none d-md-block" src="img/wb-logo-2.png"
             alt="Errisee">

      <SidebarToggler class="d-md-down-none" display="lg"/>

      <img class="pull-right mr-3 p-1 ml-auto d-none d-lg-block"
           src="img/regional-logo.jpg"
           alt="rcc">
      <img class="pull-left mr-3 p-1 d-none d-lg-block" src="img/erisee-logo.jpg"
           alt="Errise">

      <b-navbar-nav class="ml-auto">
        <b-nav-item class="">
          <DefaultHeaderDropdown/>
        </b-nav-item>
      </b-navbar-nav>
      <!--<AsideToggler class="d-none d-lg-block"/>-->
    </AppHeader>
    <div class="app-body">
      <AppSidebar fixed>
        <SidebarHeader/>
        <SidebarForm/>
        <nav class="sidebar-nav">
          <section class="ps-container scroll-area ps ps--theme_default ps--active-y">
            <ul class="nav">
              <li class="nav-item" v-if="checkRoutePermission({url: '/dashboard'})">
                <router-link class="router-link-exact-active nav-link" :to="{name: routerName.RN_DASHBOARD}">
                  <i class="nav-icon icon-speedometer"></i>
                  {{$t('DASHBOARD')}}
                </router-link>
              </li>
              <li class="nav-item" v-if="checkRoutePermission({url: '/institutions'})">
                <router-link class="router-link-exact-active nav-link" :to="{name: routerName.RN_INSTITUTIONS}">
                  <i class="nav-icon icon-home"></i>
                  {{$t('INSTITUTIONS')}}
                </router-link>
              </li>
                <li class="nav-item" v-if="checkRoutePermission({url: '/applicants'})">
                  <router-link class="router-link-exact-active  nav-link" :to="{name: routerName.RN_APPLICANTS}">
                    <i class="nav-icon icon-home"></i>
                    {{$t('APPLICANTS')}}
                  </router-link>
                </li>
                <li class="nav-item" v-if="checkRoutePermission({url: '/users'})">
                  <router-link class="router-link-exact-active  nav-link"  :to="{name: routerName.RN_USER_LIST}">
                    <i class="nav-icon icon-user"></i>
                    {{$t('USERS')}}
                  </router-link>
                </li>
              <li class="nav-item" v-if="checkRoutePermission({url: '/logs'})">
                <router-link class="router-link-exact-active  nav-link"  :to="{name: routerName.RN_LOGS}">
                  <i class="nav-icon fa fa-history"></i>
                  {{$t('Logs')}}
                </router-link>
              </li>
            </ul>
          </section>
        </nav>
        <b-button @click="logout" class="btn-logout ml-4"><i class="fa fa-power-off" aria-hidden="true"></i>{{$t("LOGOUT")}}
        </b-button>
        <SidebarFooter/>
        <SidebarMinimizer/>
      </AppSidebar>
      <main class="main">
        <!--<Breadcrumb :list="list"/>-->
        <div class="container-fluid">
          <page-transition>
            <router-view class="mt-3"></router-view>
          </page-transition>
        </div>
      </main>
      <AppAside fixed>
        <!--aside-->
        <DefaultAside/>
      </AppAside>
    </div>
    <TheFooter>

      <b-col>
        <span v-html="$t('AdminSistema')"></span>
        <span class="ml-3" v-html="$t('Telefon')"></span>
      </b-col>

      <b-col cols="3" class="text-right">
        <span v-html="$t('APPLICATION_MAKER')"></span>
      </b-col>

    </TheFooter>
  </div>
</template>
<style>
  .app-footer{
    background:#ffffff;
  }
  .scroll-area{
    position: absolute;
    height: 100%;
    margin: auto;
  }
</style>

<script>
  import nav from '@/_nav'
  import * as r_permission from '@/shared/route_permission'
  import store from '@/store/store'
  import {
    Header as AppHeader,
    SidebarToggler,
    Sidebar as AppSidebar,
    SidebarFooter,
    SidebarForm,
    SidebarHeader,
    SidebarMinimizer,
    SidebarNav,
    Aside as AppAside,
    AsideToggler,
    Footer as TheFooter,
    Breadcrumb
  } from '@coreui/vue'
  import DefaultAside from './DefaultAside'
  import DefaultHeaderDropdown from './DefaultHeaderDropdown'
  import PageTransition from '@/components/app/transition/AppTransition'
  import {USER_DATA} from '@/shared/constants.js'
  import routerName from '@/router/routeNames'
  import AppButton from "@/components/app/AppButton";
  import {cloneDeep} from 'lodash'
  import {LoginPage} from "@/shared/constants";
  import routeNames from "@/router/routeNames";

  export default {
    name: 'DefaultContainer',
    data() {
      return {
        r_permission,
        routerName,
        navList:[]
      }
    },
    components: {
      AppButton,
      AsideToggler,
      AppHeader,
      AppSidebar,
      AppAside,
      TheFooter,
      Breadcrumb,
      DefaultAside,
      DefaultHeaderDropdown,
      SidebarForm,
      SidebarFooter,
      SidebarToggler,
      SidebarHeader,
      SidebarNav,
      SidebarMinimizer,
      PageTransition
    },
    computed: {
      name() {
        return this.$route.name
      },
      user() {
        return store.getters['user/getUser']
      },
      list() {
        return this.$route.matched.filter((route) => route.meta.label)
      },
      navigation_list() {

          return this.navList.items.reduce((result, el) => {
            if (this.checkRoutePermission(el)) {
              result.push(el);
            }
            return result;
          }, []);

      },
    },
    methods: {
      logout() {
        this.$store.dispatch('auth/actionLogout').then(() => {
          if (process.env.NODE_ENV === 'production') {

            window.location.href = LoginPage

          } else {
            this.$router.replace({name: routeNames.RN_LOGIN})
          }
        })
      },
      checkRoutePermission(navItem) {
        if (!navItem.url) return
        const routeMeta = this.$router.resolve(navItem.url).route.meta || {}
        const hasPermission = (typeof (routeMeta.permission_id) === 'undefined' || this.checkPermission(routeMeta.permission_id))
        return hasPermission
      }
    },
    created(){
      this.navList = cloneDeep(nav)
    },
    beforeRouteEnter(to, from, next) {

      if (window.location !== window.parent.location) {
        window.parent.location.replace(to.fullPath)
      } else {
        next(() => {
          document.body.classList.remove('page-login')

        })
      }
    },

  }
</script>
